import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBoltLightning,
    faCoins,
    faFire,
    faPerson,
    faSignOut
} from "@fortawesome/free-solid-svg-icons";

import logo from "../../../assets/images/logo.svg";
import { useLanguage } from "../../../context/LanguageProvider";
import { ROUTES } from "../../../shared/constants/routes";
import useEnergy from "../../../shared/hooks/useEnergy";
import { toFarsiNumber } from "../../../shared/utils/commonUtils";
import ButtonLink from "../../../shared/components/elements/ButtonLink";
import StatBar from "../../../shared/components/elements/StatBar";
import type { StatItem } from "../../../shared/components/elements/StatBar";
import Wrapper from "../../../shared/components/layout/Wrapper";

import { LEARN_MESSAGES } from "../messages";

interface LearnHeaderProps {
    userId?: number | string | null;
    courseId?: string;
    title?: string;
    xp?: number;
    credit?: number;
    streak?: number;
    showPurchaseButton?: boolean; // True only for courses the user hasn't bought
}

const LearnHeader = ({
                         userId = null,
                         courseId,
                         title = "",
                         xp = 0,
                         credit = 0,
                         streak = 0,
                         showPurchaseButton = false
                     }: LearnHeaderProps) => {
    const { lang, t } = useLanguage();
    const { energy } = useEnergy(userId);

    // "…" until the energy value arrives
    const energyText =
        energy === null || energy === undefined
            ? "…"
            : lang === "fa"
                ? toFarsiNumber(energy)
                : energy;

    const stats: StatItem[] = [
        { key: "credit", label: LEARN_MESSAGES.credit, value: credit, icon: faCoins },
        { key: "streak", label: LEARN_MESSAGES.streak, value: streak, icon: faFire },
        { key: "xp", label: LEARN_MESSAGES.xp, value: xp, icon: faPerson },
        { key: "energy", label: LEARN_MESSAGES.energy, value: energyText, icon: faBoltLightning }
    ];

    return (
        <header className="mt-4">
            <Wrapper>
                <div className="w-full flex flex-1 items-center">
                    <div className="flex flex-col items-center lg:flex-row">
                        <div className="flex gap-x-3 items-center">
                            <img src={logo} alt="" className="h-16" />
                            <span className="text-2xl font-bold">{t.nav.brand}</span>
                        </div>

                        <div className="hidden lg:flex justify-between mx-10 items-center">
                            <h1 className="text-3xl">{title}</h1>
                        </div>
                    </div>

                    <div className="mr-auto flex gap-x-5">
                        {showPurchaseButton && courseId && (
                            <ButtonLink to={ROUTES.purchaseCourse(lang, courseId)}>
                                <span>{LEARN_MESSAGES.buyCourse}</span>
                                <FontAwesomeIcon icon={faCoins} />
                            </ButtonLink>
                        )}

                        <StatBar items={stats} className="w-72 hidden lg:flex relative" />

                        <ButtonLink to={ROUTES.myCourses(lang)}>
                            <span className="sr-only">{LEARN_MESSAGES.backToCourses}</span>
                            <FontAwesomeIcon icon={faSignOut} className="rotate-180" />
                        </ButtonLink>
                    </div>
                </div>
            </Wrapper>
        </header>
    );
};

export default LearnHeader;